import { ReactElement } from "react"

import AmendHpDeviceForm from "../../../../components/devices/lct/hp/amendHpDeviceForm"
import NewHpDeviceAmendmentProvider from "../../../../components/devices/lct/hp/providers/newHpDeviceAmendmentProvider"

/** Root webpage for amending an HP device */
const AmendHpDevice = (): ReactElement => (
    <NewHpDeviceAmendmentProvider>
        <AmendHpDeviceForm />
    </NewHpDeviceAmendmentProvider>
)

export default AmendHpDevice
